/**
 * Bundle props are passed on the initial load from the server. They should be
 * configuration values that are needed globally in the application and do not
 * change during the lifetime of the application.
 */
import { atom, useAtomValue } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';
import invariant from 'invariant';
import { WhiteLabelStyles } from 'signer-app/white-labeling/types';

const bundlePropsAtom = atom<BundleProps>({} as BundleProps);

type BundleProps = {
  whiteLabelStyles: WhiteLabelStyles;
  /**
   * The `whiteLabelStyles` will always be present in the response, so we
   * need this extra flag to know if we're using customized styles
   */
  hasCustomStyles: boolean;

  customLogoUri: string | undefined;

  signerDbxAccountId?: string;
  signerAccountId?: string;
  tsmGuid: string;
  embeddedData: {
    parentUrl: string;
    redirectUrl: string;
    isEmbeddedSigning: boolean;
  };
  signers?: {
    key: string;
    name: string;
    email: string;
    tsmGuid: string;
  }[];
};

export function useHydrateBundleProps(props: BundleProps) {
  useHydrateAtoms([[bundlePropsAtom, props]]);
}

export function useBundleProps() {
  const bundleProps = useAtomValue(bundlePropsAtom);

  invariant(
    bundleProps,
    'Bundle props must be hydrated before they can be used',
  );

  return bundleProps;
}
